import { injectable, container } from 'tsyringe';
import { UipTranslationService } from '@/Feature/Uip/platform/app/services';
import { createElement } from '@gn-audio/core/common/templating';
import { IUipTranslation } from '@/Feature/Uip/platform/app/models';
import { getTopMenuElement } from '@gn-audio/core/common/utilities';

import { UipMenuItemMyJabraComponent } from '../uip-menu-item-my-jabra/uip-menu-item-my-jabra.component';
import { UipMenuItemLogoutComponent } from '../uip-menu-item-logout/uip-menu-item-logout.component';
import { UipMenuItemOrderHistoryComponent } from '../uip-menu-item-order-history/uip-menu-item-order-history.component';

import './uip-menu.component.scss';

import template from './uip-menu.component.html';

@injectable()
export class UipMenuComponent {
  private element?: Element;
  private closeElement?: Element;

  private logout?: UipMenuItemLogoutComponent;
  private orderHistory?: UipMenuItemOrderHistoryComponent;
  private myJabra?: UipMenuItemMyJabraComponent;

  constructor(private readonly translationService: UipTranslationService) { }

  public async render(containerElement: Element) {
    const translations: IUipTranslation = await this.translationService.translations;
    this.element = createElement(template, {}, translations);
    containerElement.insertAdjacentElement('afterbegin', this.element);
    this.closeElement = this.element.querySelector('.uip-item-menu__toolbar-action');
    this.closeElement.addEventListener('click', this.close);

    const yourAccountGroup = this.element.querySelector('.uip-item-menu__group');

    this.myJabra = container.resolve(UipMenuItemMyJabraComponent);
    if (await this.myJabra.shouldRender()) {
      await this.myJabra.render(yourAccountGroup);
    }

    // Should be enabled only if SFCC basket is enabled?
    this.orderHistory = container.resolve(UipMenuItemOrderHistoryComponent);
    if (await this.orderHistory.shouldRender()) {
      await this.orderHistory.render(yourAccountGroup);
    }

    this.logout = container.resolve(UipMenuItemLogoutComponent);
    if (this.logout.shouldRender()) {
      await this.logout.render(yourAccountGroup);
    }
  }

  public destroy() {
    this.closeElement.removeEventListener('click', this.close);
    this.myJabra?.destroy();
    this.logout?.destroy();
    this.orderHistory?.destroy();
    this.element?.remove();
  }

  private close = () => {
    getTopMenuElement()
      .dispatchEvent(new Event('blur'));
  };
}
